<template>
  <v-app :class="'uitheme-' + uiTheme">
    <div class="app-layout" :class="{ 'app-layout--v3': showHeaderAndMenu && $loginState.user?.ui_layout === 'V2' }" :style="{ '--side-menu-width': (showHeaderAndMenu && $loginState.user?.ui_layout === 'V2') ? '64px' : '0px' }">
      <SideMenu v-if="showHeaderAndMenu && $loginState.user?.ui_layout === 'V2'"></SideMenu>
      <div class="app-content">
        <HeaderOld
          v-if="showHeaderAndMenu && $loginState.isAuthenticated && !newUi"
          :recentDocs="recentDocs"
          :qaActions="myQaActions"
          @addDocument="addDocument"
          @openDocument="openDocument"
          @openUserSettings="userSettings = true"
          @openCookiePreferences="openCookiePreferences"
          @logout="logout"
        />
        <HeaderNew
          v-if="showHeaderAndMenu && $loginState.isAuthenticated && newUi"
          :recentDocs="recentDocs"
          :qaActions="myQaActions"
          :settingsExpanded="userSettings"
          @addDocument="addDocument"
          @openDocument="openDocument"
          @openUserSettings="userSettings = true"
          @openCookiePreferences="openCookiePreferences"
          @impersonate="impersonate"
          @impersonateRevert="impersonateRevert"
          @sessionExpired="sessionExpired"
          @logout="logout"
          @handleGatewayEvent="handleGatewayEvent"
        />
    <!--
      Atlas flyout — globally mounted so the conversation persists
      across route navigation and modal lifecycle (singleton pattern in
      `useAtlasFlyout()`). Only renders when authenticated; v-if at this
      level lets us avoid initialising the chat composable for logged-out
      users.
    -->
    <AtlasFlyout v-if="$loginState.isAuthenticated && newUi"
      @openDocument="openDocument" />
    <div class="app-body">
      <ContextDrawer v-if="$loginState.user?.ui_layout === 'V2'"></ContextDrawer>
      <v-main
        class="mainContent"
        :class="{
          'mainContent--atlas-open': atlasPanelOpen,
          'mainContent--atlas-resizing': atlasResizing,
        }"
        :style="atlasPanelOpen ? { paddingRight: atlasFlyoutWidth + 'px' } : null">
        <router-view
          v-if="$loginState.user && !permissionsReloading"
          :qaActions="myQaActions"
          @sessionExpired="sessionExpired"
          @openDocument="openDocument"
          @copyDocument="copyDocument"
          @documentCreated="documentCreated"
          @addDocument="addDocument"
          @evaluateNewDocument="evaluateNewDocument"
          @documentChangedHandler="documentChangedHandler"
          @impersonate="impersonate"
        />
      </v-main>
    </div>
      </div>
    </div>
    <Login
      :doLogin="doLogin"
      :reEnterPassword="$loginState.reEnterPassword"
      :setPasswordToken="setPasswordToken"
      :setPasswordType="setPasswordType"
      @LoggedIn="processLogin"
      @Cancelled="cancelLogin"
      @openCookiePreferences="openCookiePreferences"
    />
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <!--
      `:retain-focus="false"` lets focus move OUT of the dialog and into
      the AtlasFlyout's chat input. Vuetify's default focus-trap is the
      right behaviour for a transient confirm dialog, but this dialog
      hosts the entire document view AND we deliberately render the
      flyout above it — without this prop the user can't click into the
      flyout's textarea while a document is open.
    -->
    <v-dialog
      v-model="showDocument"
      v-if="$loginState.user && !permissionsReloading"
      persistent
      fullscreen
      hide-overlay
      :retain-focus="false"
      transition="dialog-bottom-transition"
      no-click-animation
    >
      <template v-if="selectedDocumentId">
        <DocumentFullNEW
          v-if="
            $loginState.user &&
            $loginState.user.settings.some(
              (s) =>
                s.setting === 'document_viewer' &&
                s.value.indexOf('docFull') === 0
            )
          "
          :documentId="selectedDocumentId"
          :viewAction="selectedDocumentViewAction"
          :isCopied="docCopied"
          :isCopiedLink="docCopiedLink"
          :isNew="isNewDocument"
          :useInline="
            $loginState.user.settings.some(
              (s) => s.setting === 'document_viewer' && s.value === 'docFull'
            )
          "
          :viewSource="viewSourceDoc"
          :openFlex="openFlex"
          @copyDocument="copyDocument"
          @openDocument="openDocument"
          @close="closeDocument"
          @closeDocument="closeDocument"
          @documentHeaderSaved="documentHeaderSaved"
          @sessionExpired="sessionExpired"
          @documentLoadError="documentLoadError"
        ></DocumentFullNEW>
        <DocumentFull
          v-else
          :documentId="selectedDocumentId"
          :viewAction="selectedDocumentViewAction"
          :isCopied="docCopied"
          @copyDocument="copyDocument"
          @openDocument="openDocument"
          @close="closeDocument"
          @closeDocument="closeDocument"
          @documentHeaderSaved="documentHeaderSaved"
          @sessionExpired="sessionExpired"
        ></DocumentFull>
      </template>
    </v-dialog>
    <v-dialog
      v-model="showExternalDocument"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <DocumentExternal
        :documentId="selectedDocumentId"
        :viewAction="selectedDocumentViewAction"
        :isCopied="docCopied"
        @copyDocument="copyDocument"
        @openDocument="openDocument"
        @close="closeExternalDocument"
        @closeExternalDocument="closeExternalDocument"
        @documentHeaderSaved="documentHeaderSaved"
        @sessionExpired="sessionExpired"
      ></DocumentExternal>
    </v-dialog>
    <v-dialog
      v-model="showCookies"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <Cookies
        @closeCookies="closeCookies"
        @sessionExpired="sessionExpired"
      ></Cookies>
    </v-dialog>
    <CookieBanner
      v-if="!cookieConsentGiven && !showCookiePreferences"
      @accept-all="acceptAllCookies"
      @reject-all="rejectAllCookies"
      @customise="openCookiePreferences"
      @more-info="showCookieDialog"
    />
    <CookiePreferences
      v-model="showCookiePreferences"
      @saved="onCookieConsentSaved"
    />
    <v-dialog
      v-model="showAddDocument"
      :fullscreen="!newUi"
      transition="dialog-bottom-transition"
    >
      <DocumentAdd
        v-if="!newUi"
        :open="showAddDocument"
        @closed="showAddDocument = false"
        @created="documentCreated"
        @sessionExpired="sessionExpired"
        @openDocument="openDocument"
      ></DocumentAdd>
      <DocumentAddNew
        v-else-if="showAddDocument"
        :targetDoc="defaultDoc"
        :open="showAddDocument"
        @closed="showAddDocument = false"
        @created="documentCreated"
        @sessionExpired="sessionExpired"
        @openDocument="openDocument"
        @copyDocument="copyDocument"
      ></DocumentAddNew>
    </v-dialog>
    <v-dialog
      v-model="showEvaluateNew"
      :fullscreen="!newUi"
      transition="dialog-bottom-transition"
      max-width="800px"
    >
      <EvaluateNew
        :open="showEvaluateNew"
        @closed="showEvaluateNew = false"
        @docCreated="documentCreated"
        @sessionExpired="sessionExpired"
        @openDocument="openDocument"
      >
      </EvaluateNew>
    </v-dialog>

    <Loading :isVisible="isLoading" />
    <v-snackbar
      v-model="showErrorSnack"
      :timeout="snackTimeout"
      :color="snackColor"
      :multi-line="errorText.length > 50"
      top
    >
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="showErrorSnack = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-navigation-drawer
      v-model="userSettings"
      right
      temporary
      fixed
      hide-overlay
      width="360"
      style="z-index:21;"
    >
      <UserSettings
        v-if="userSettings"
        :qaActions="myQaActions"
        @closed="userSettings = false"
        @themeChange="applyTheme"
      />
    </v-navigation-drawer>
    <div class="network-error" v-if="networkError">
      <v-alert  type="warning">
        Network error, attempting to reconnect...
      </v-alert>
    </div>
  </v-app>
</template>
<script>
import Login from "@/components/cLogin"; // @ is an alias to /src
import axios from "axios";
import axiosRetry from 'axios-retry';
import utils from "@/common/utils.js";
import HeaderOld from "@/components/cHeaderOld.vue";
import HeaderNew from "@/components/cHeaderNew.vue";
import SideMenu from "@/components/layout/sideMenu.vue";
import ContextDrawer from "@/components/layout/contextDrawer.vue";
import DocumentFullNEW from "@/components/cDocumentFullNEW";
import DocumentFull from "@/components/cDocumentFull";
import DocumentAdd from "@/components/cDocumentAdd";
import DocumentAddNew from "@/components/cDocumentAddNew";
import EvaluateNew from '@/components/levellingEvaluation/EvaluateNew.vue'
import DocumentExternal from "@/components/cDocumentExternal";
import UserSettings from "@/components/cUserSettings";
import ResponseHandler from "@/components/ResponseHandler";
import Cookies from "@/components/cCookies";
import CookieBanner from "@/components/cCookieBanner";
import CookiePreferences from "@/components/cCookiePreferences";
import cookieConsent from "@/common/cookieConsent";
import AtlasFlyout from "@/components/agent/AtlasFlyout.vue";
import { useAtlasFlyoutLayout, closeAtlasFlyout } from "@/composables/agent/atlasFlyout";
import { computed } from "vue";
import { mapState } from "vuex";

export default {
  props: {
    source: String,
  },
  components: {
    Login,
    ResponseHandler,
    HeaderOld,
    HeaderNew,
    DocumentFullNEW,
    DocumentFull,
    DocumentAdd,
    DocumentAddNew,
    EvaluateNew,
    UserSettings,
    Cookies,
    CookieBanner,
    CookiePreferences,
    DocumentExternal,
    SideMenu,
    ContextDrawer,
    AtlasFlyout,
  },
  setup() {
    // Read shared Atlas flyout state so v-main can reserve matching
    // right-padding when the panel is open — turns the overlay into a
    // proper side panel that shrinks router-view rather than covering
    // it. `globalHidden` keeps padding off on the full-page /agent
    // route AND while a host page is rendering an inline Atlas panel
    // (Document_Holder's Atlas tab) — in those cases the slide-in
    // itself doesn't render, so reserving space for it would leave a
    // dead gutter.
    const { open, globalHidden, flyoutWidth, resizing } = useAtlasFlyoutLayout();
    const atlasPanelOpen = computed(() => open.value && !globalHidden.value);
    return {
      atlasPanelOpen,
      atlasFlyoutWidth: flyoutWidth,
      atlasResizing: resizing,
    };
  },
  data: () => ({
    response: null,
    stateRefreshTimeout: null,
    refreshInProgress: false,
    selectedUserIdx: 1,
    doLogin: false,
    setPasswordToken: null,
    setPasswordType: null,
    isLoading: false,
    dialog: false,
    drawer: null,
    showUserSettings: false,
    userSettings: false,
    qaActions: [],
    selectedDocumentId: null,
    selectedDocumentViewAction: null,
    showDocument: false,
    openFlex: false,
    showExternalDocument: false,
    docCopied: false,
    docCopiedLink: false,
    showAddDocument: false,
    showEvaluateNew: false,
    isNewDocument: false,
    refDocument: null,
    recentDocs: [],
    showCookies: false,
    showCookiePreferences: false,
    cookieConsentGiven: cookieConsent.hasValidConsent(),
    errorText: "",
    showErrorSnack: false,
    snackColor: "error",
    snackTimeout: 4000,
    defaultDoc: "",
    permissionsReloading: false,
    getTasksTimeout: null,
    viewSourceDoc: false,
    networkError: false,
    sideMenuExpanded: false,
  }),
  created() {
    axios.defaults.withCredentials = true;
    axios.interceptors.request.use(
      (config) => {
        config.baseURL = process.env.VUE_APP_API_BASE_URL;
        if (
          this.$loginState.rmapiAccessToken &&
          this.$loginState.rmapiAccessToken !== "undefined"
        ) {
          config.headers["Authorization"] =
            "Bearer " + this.$loginState.rmapiAccessToken;
        }
        config.metadata = { startTime: new Date() };
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      (response) => {
        if (response.data && response.data.access_token) {
          this.$loginState.rmapiAccessToken = response.data.access_token;
          this.$router.setAppName((response.data.user && response.data.user.client
              ? response.data.user.client_display_name + " "
              : "") + "Role Mapper");
          this.setStateRefreshTimer(response.data);
        }
        this.networkError = false;
        return response;
      },
      async (error) => {
        const originalRequest = error.config;
        if (!originalRequest) {
          console.log(error)
          return;
        }
        error.config.metadata.endTime = new Date();
        error.duration = error.config.metadata.endTime - error.config.metadata.startTime;

        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 401:
              if (
                originalRequest._retry ||
                originalRequest.url.includes("auth/loginstate")
              ) {
                this.reloadRoot();
              } else if (originalRequest.url !== "auth/login/") {
                //refresh access token and retry
                console.log("refreshing token before retry");
                await this.refreshLoginState();
                originalRequest._retry = true;
                return axios(originalRequest);
              }
              return Promise.reject({ ...error });
            case 403:
              console.log(`${originalRequest.url} - forbidden`);
              return Promise.reject({ ...error });
            case 404:
              alert("page not exist");
              return Promise.reject({ ...error });
            case 500:
            case 504:
              console.log(error);
              return Promise.reject({ ...error });
          }
        }

        const retryCount = Number(originalRequest._retryCount) || 0;
        if (axiosRetry.isNetworkOrIdempotentRequestError(error) && retryCount < 10 && error.duration < 30000) {
          this.networkError = axiosRetry.isNetworkError(error);
          console.log(`network error, retry attempt #${retryCount}`);
          await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
          originalRequest._retryCount = retryCount + 1;
          return axios(originalRequest);
        }

        this.networkError = false;
        return Promise.reject({ ...error });
      }
    );
  },
  mounted: function () {
    this.getAppState();
    window.addEventListener('keydown', this.escKeyHandler);
  },
  destroyed () {
    window.removeEventListener('keydown', this.escKeyHandler);
  },
  watch: {
    showDocument(open) {
      this.handleFullScreenDialog(open);
    },
    docsInitialised(val) {
      if (!val && this.$loginState.isAuthenticated)
        this.logout();
    },
    "$route.params.user"(user) {
      if (user !== undefined && user != this.selectedUserIdx)
        this.refreshLoginState();
    },
    /* A chrome-less route owns the whole viewport — today that's the levelling
       evaluation (/evaluate). The Atlas panel would squeeze that surface, and with
       the header gone there's no button left to close it with, so close it on the
       way in. Keyed off the same computed the header and side menu read, so any
       future full-screen route inherits the behaviour.

       `closeAtlasFlyout()` rather than the hook's `close()`: the full hook builds
       the chat singleton, which is exactly what setup() avoids here (it would fire
       /agent/init before created() installs the axios baseURL interceptor). */
    showHeaderAndMenu: {
      immediate: true,
      handler(shown) {
        if (!shown) closeAtlasFlyout();
      },
    },
  },
  computed: {
    myQaActions: function () {
      return this.qaActions
        .filter((a) => (a.meta && (this.newUi ? a.meta.newUi : a.meta.oldUi)))
        .sort((a, b) => {
          const asec = a.meta.section || "Unknown",
            bsec = b.meta.section || "Unknown";
          return asec === bsec ? 0 : asec < bsec ? 1 : -1;
        });
    },
    sideMenuItems: function () {
      let menuItems = [];
      const actions = this.qaActions
        .filter((a) => (a.meta && (this.newUi ? a.meta.newUi : a.meta.oldUi)))
        .sort((a, b) => {
          const asec = a.meta.section || "Unknown",
            bsec = b.meta.section || "Unknown";
          return asec === bsec ? 0 : asec < bsec ? 1 : -1;
        });

      menuItems = actions
        .filter(
          (a) =>
            !this.$router.menuSections.some((s) => s.name == a.meta.section)
        )
        .map((i) => {
          const iconSplit = i.meta?.icon?.split(" ") || [];
          return {
            name: i.name,
            path: i.path,
            icon: iconSplit[0],
            iconClass: iconSplit.length ? iconSplit[1] : "",
            text: i.meta.text,
          };
        });

      this.$router.menuSections.forEach((s) => {
        const sectionItems = actions
          .filter((a) => s.name == a.meta.section)
          .map((i) => {
            const iconSplit = i.meta?.icon?.split(" ") || [];
            return {
              name: i.name,
              path: i.path,
              icon: iconSplit[0],
              iconClass: iconSplit.length ? iconSplit[1] : "",
              text: i.meta.text,
            };
          });
        if (sectionItems.length == 1) {
          menuItems.push(sectionItems[0]);
        } else if (sectionItems.length > 1) {
          menuItems.push({
            name: s.name,
            icon: s.icon,
            iconClass: s.iconClass,
            text: s.name,
            expanded: sectionItems.some((i) => i.name == this.$route.name),
            subItems: sectionItems,
          });
        }
      });
      return menuItems;
    },
    showHeaderAndMenu: function() {
      return this.$route.meta?.hideHeaderAndMenu !== true
    },
    ...mapState({
      screenName: (state) => state.header.screenName,
      uiTheme: (state) => state.theme.name,
      newUi: (state) => state.theme.newUi,
      docsInitialised: (state) => state.docs.initialised,
    }),
  },
  methods: {
    registerGatewayListeners() {
      //this.$eventGateway.$on("document-translate-create", this.translateComplete);
      //this.$eventGateway.$on("document-translate-update", this.translateUpdate);
    },
    connectionEvent() {
      //alert(this.$eventGateway.status());
    },
    handleGatewayEvent(event) {
      switch (event) {
        case "connect":
          this.connectToGateway();
          break;
      }
    },
    connectToGateway() {
      this.useGateway = this.$loginState.user.settings.some(
        (s) => s.setting === "use_event_gateway" && s.value === "true"
      ) || true; // TODO: remove fallback once use_event_gateway is enabled for all users
      if (this.useGateway) {
        // Token may not be available yet (header fires before login response).
        // Wait until we have one before connecting.
        if (!this.$loginState.rmapiAccessToken) {
          const unwatch = this.$watch(
            () => this.$loginState.rmapiAccessToken,
            (token) => {
              if (token) {
                unwatch();
                this.connectToGateway();
              }
            }
          );
          return;
        }
        this.$eventGateway.$on("connected", () => {
          this.registerGatewayListeners();
        });
        this.$eventGateway.connect(this.$loginState.user.name, this.$loginState.rmapiAccessToken);
      }
    },
    reloadRoot() {
      if (
        this.$router.currentRoute &&
        this.$router.currentRoute.fullPath !== "/" &&
        this.$router.currentRoute.fullPath !== "/sso/"
      ) {
        this.$router.replace({
          path: localStorage.getItem("rmsso") === "1" ? "/sso/" : "/",
        });
        location.reload();
      }
    },
    handleFullScreenDialog(hide) {
      //ensure we don't end up with double scrollbars when fullscreen dialog is open
      if (hide) {
        document.documentElement.classList.add("noscroll");
        window.addEventListener("keydown", this.handlePageUpDown);
      } else {
        document.documentElement.classList.remove("noscroll");
        window.removeEventListener("keydown", this.handlePageUpDown);
      }
    },
    handlePageUpDown(e) {
      if (
        document.activeElement &&
        (document.activeElement.tagName === "BODY" ||
          document.activeElement.classList.contains(
            "v-dialog__content--active"
          ))
      ) {
        switch (e.code) {
          case "PageDown":
            this.scrollDialog(600);
            break;
          case "PageUp":
            this.scrollDialog(-600);
            break;
          case "ArrowDown":
            this.scrollDialog(60);
            break;
          case "ArrowUp":
            this.scrollDialog(-60);
            break;
        }
      }
    },
    escKeyHandler (event) {
      if (event.code === 'Escape') {
        this.userSettings = false;
      }
    },
    scrollDialog(y) {
      const dialog = document.getElementsByClassName(
        "v-dialog v-dialog--active"
      );
      if (dialog.length) {
        dialog[0].scrollBy({
          top: y,
          left: 0,
          behavior: "smooth",
        });
      }
    },
    documentChangedHandler(f) {
      this.notifyDocumentChange = f;
    },
    sessionExpired(err) {
      console.log("sessionExpired: " + err);
      if (err && err.response && err.response.status === 401) {
        this.$loginState.reEnterPassword = true;
        this.showLogin();
      }
    },
    cancelLogin() {
      this.$loginState.isAuthenticated = false;
      this.$loginState.user = null;
      this.setAvailableActions();
    },
    setStateRefreshTimer(data) {
      if (data.token_expiry) {
        if (this.stateRefreshTimeout) {
          clearTimeout(this.stateRefreshTimeout);
          this.stateRefreshTimeout = undefined;
        }
        //refresh token 10 secs before it expires
        const expTimeFromNow =
          new Date(data.token_expiry) - Date.now() - 10 * 1000;
        if (expTimeFromNow > 0) {
          this.stateRefreshTimeout = setTimeout(
            () => this.refreshLoginState(),
            expTimeFromNow
          );
        }
      }
    },
    async refreshLoginState() {
      if (!this.refreshInProgress) {
        this.refreshInProgress = true;
        let possibleError = false;
        let selectedUserIdx = this.selectedUserIdx;
        const path = location.hash.split("/").filter((p) => p && p !== "#");
        if (path.length > 1 && path[0] === "u" && path[1] && !isNaN(Number(path[1]))) {
          selectedUserIdx = Number(path[1]);
        }

        await axios
          .post("auth/loginstate/", {
            impersonatingUserIndex: selectedUserIdx,
          })
          .then((resp) => {
            possibleError = true;
            if (resp.data.Status === "OK") {
              if (
                !this.$loginState.isAuthenticated ||
                !this.$loginState.user ||
                this.$loginState.user.user_id !== resp.data.user.user_id ||
                this.qaActions.length === 0
              ) {
                this.permissionsReloading = true;
                this.unloadClient();
                this.processLogin(resp.data);
                setTimeout(() => {
                  this.permissionsReloading = false;
                }, 50);
              } else {
                this.validateCurrentRoute();
              }
            } else {
              this.permissionsReloading = false;
              this.errMessage = resp.data.message;
              this.logout();
              this.showLogin();
            }
            this.isLoading = false;
            this.refreshInProgress = false;
          })
          .catch((err) => {
            this.refreshInProgress = false;
            this.$loginState.isAuthenticated = false;
            this.isLoading = false;
            this.errMessage = err;
            if (possibleError) {
              alert("JS Error: " + err);
            } else if (err.response && err.response.status === 401) {
              this.logout();
              this.showLogin();
            }
          });
      } else {
        while (this.refreshInProgress) {
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
      }
    },
    unloadClient() {
      this.$store.dispatch("docs/unload");
      this.$store.dispatch("hierarchies/unload");
      this.$store.dispatch("tasks/unload");
      this.$store.dispatch("settings/unload");
      this.$store.dispatch("files/unload");
      this.closeDocument();
      this.$router.clearClientRoutes();
    },
    processLogin(data) {
      const user = data.user;
      this.setPasswordToken = "";
      this.$loginState.isAuthenticated = true;
      this.$loginState.setUser(user);
      this.selectedUserIdx = user.impersonatedUserIndex;

      this.applyTheme(this.$loginState.getUserSetting("ui_theme"));

      localStorage.setItem("rmsso", user.sso);
      this.$loginState.sso = user.sso === "1";
      this.errMessage = "";
      this.doLogin = false;
      this.setAvailableActions();
      this.recentDocs = utils.getRecentDocs(this.$loginState);
      this.$store.dispatch("docs/init", this.$loginState);
      this.$store.dispatch("hierarchies/init");
      this.$store.dispatch("tasks/init");
      this.$store.dispatch("settings/init");
      if (this.$loginState.isInternal) this.$store.dispatch("customers/init");
      this.checkForRedirectLink();
    },
    acceptAllCookies() {
      const all = {};
      cookieConsent.CATEGORIES.forEach((c) => { all[c] = true; });
      cookieConsent.setConsent(all);
      this.cookieConsentGiven = true;
    },
    rejectAllCookies() {
      cookieConsent.setConsent({});
      this.cookieConsentGiven = true;
    },
    openCookiePreferences() {
      this.showCookiePreferences = true;
    },
    onCookieConsentSaved() {
      this.cookieConsentGiven = cookieConsent.hasValidConsent();
    },
    extractFromUrl() {
      let hashUrl = false;
      let path = location.pathname.split("/").filter((p) => p);
      if (path.length === 0) {
        //prob hash
        hashUrl = true;
        path = location.hash.split("#/").filter((p) => p);
      }
      let path1 = path[0];

      let searchParams = location.search.split("=");

      if (hashUrl && path1 !== undefined) {
        let tempSearch = path1.split("?");
        if (tempSearch.length == 2) {
          searchParams = tempSearch[1].split("=");
        }
        path[0] = tempSearch[0];
        path1 = path[0];
      }

      if (
        path.length === 1 &&
        ["viewnotification", "viewtask"].indexOf(path1) >= 0
      ) {
        if (searchParams.length === 2) {
          return Number(searchParams[1]);
        }
      }

      if (path.length === 1 && ["viewdoc"].indexOf(path1.toLowerCase()) >= 0) {
        if (searchParams.length === 2) {
          return searchParams[1];
        }
      }
    },
    impersonate(request) {
      this.isLoading = true;
      this.permissionsReloading = true;
      let possibleError = false;

      axios
        .post("auth/impersonate/", request)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.unloadClient();
            this.processLogin(resp.data);
          }
          this.isLoading = false;
          this.permissionsReloading = false;
        })
        .catch((err) => {
          this.errMessage = err;
          this.isLoading = false;
          this.permissionsReloading = false;
          if (possibleError) {
            alert("JS Error: " + err);
          } else {
            alert("Server Error: " + err.response?.statusText);
            console.log(err);
          }
        });
    },
    impersonateRevert() {
      this.isLoading = true;
      this.permissionsReloading = true;
      let possibleError = false;

      axios
        .post("auth/impersonateRevert/")
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.unloadClient();
            if (
              resp.data.user.client_type === "INTERNAL" &&
              this.$route.name !== "default"
            )
              this.$router.replace({ name: "default" });
            this.processLogin(resp.data);
          }
          this.isLoading = false;
          this.permissionsReloading = false;
        })
        .catch((err) => {
          this.errMessage = err;
          this.isLoading = false;
          this.permissionsReloading = false;
          if (possibleError) {
            alert("JS Error: " + err);
          } else {
            alert("Server Error: " + err.response?.statusText);
            console.log(err);
          }
        });
    },
    getAppState() {
      //check for password reset
      this.setPasswordToken = null;
      this.setPasswordType = null;
      let hashUrl = false;
      let path = location.pathname.split("/").filter((p) => p);
      if (path.length === 0) {
        //prob hash
        hashUrl = true;
        path = location.hash.split("/").filter((p) => p && p !== "#");
      }
      let path1 = path[0];
      if (path.length === 2 && (path1 === "reset" || path1 === "set")) {
        this.setPasswordToken = path[1];
        this.setPasswordType = path1;
        this.showLogin();
        return;
      }

      if (path.length === 1 && path1 === "disabled") {
        this.showErrorSnack = true;
        this.errorText = "Login for this user is currently disabled";

        this.showLogin();
        return;
      }

      let searchParams = location.search.split("=");

      if (hashUrl && path1 !== undefined) {
        let tempSearch = path1.split("?");
        if (tempSearch.length == 2) {
          searchParams = tempSearch[1].split("=");
        }
        path[0] = tempSearch[0];
        path1 = path[0];
      }

      if (
        path.length === 1 &&
        ["viewnotification", "viewtask"].indexOf(path1) >= 0
      ) {
        if (searchParams.length === 2) {
          if (!this.$loginState.isAuthenticated) {
            let id = Number(searchParams[1]);
            localStorage.setItem(path1, id);
          }
        }
      }

      if (path.length === 1 && ["viewdoc"].indexOf(path1.toLowerCase()) >= 0) {
        if (searchParams.length === 2) {
          if (!this.$loginState.isAuthenticated) {
            let id = searchParams[1];
            localStorage.setItem(path1, id);
          }
        }
      }

      // Atlas MCP OAuth: an external app is connecting (?atlas_oauth_txn= lands
      // in the hash for our hash-routed app). Force a fresh login modal instead
      // of auto-authenticating from any existing session, so the user can sign
      // in as whoever they want for this connection. cLogin handles the bridge
      // on submit.
      if (
        /[?&]atlas_oauth_txn=/.test(location.hash) ||
        /[?&]atlas_oauth_txn=/.test(location.search)
      ) {
        this.isLoading = false;
        this.showLogin();
        return;
      }

      this.isLoading = true;
      this.refreshLoginState();
    },
    async checkForRedirectLink() {
      if (!this.checkForLink("viewnotification")) {
        if (!this.checkForLink("viewtask")) {
          this.checkForDocLink();
        }
      }
    },
    checkForDocLink() {
      let id = "";
      let linkType = "viewdoc";
      if (localStorage.getItem(linkType)) {
        id = localStorage.getItem(linkType);
      } else {
        id = this.extractFromUrl();
      }
      if (id !== undefined && id !== "") {
        axios
          .get("document/docswithparts/" + id, {})
          .then((resp) => {
            if (resp.data.Status === "OK") {
              this.openDocument(resp.data.Data.documents[0], false);
              localStorage.removeItem(linkType);
            }
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) {
              this.$emit("sessionExpired", err);
            } else {
              console.log(err);
              this.response = err.response
                ? err.response.data
                : { message: "Unexpected Error" };
            }
            this.isLoading = false;
          });
      }
    },
    checkForLink(linkType) {
      let id = 0;

      if (localStorage.getItem(linkType)) {
        id = Number(localStorage.getItem(linkType));
      } else {
        id = this.extractFromUrl();
      }

      if (id > 0) {
        axios
          .get(`workflow/${linkType}/${id}`)
          .then((resp) => {
            if (resp.data.Status === "OK") {
              if (resp.data.Data && resp.data.Data.viewAction) {
                if (resp.data.Data.task.task_action === 'LEVELLING_EVALUATION' && resp.data.Data.document)
                  this.$router.push({ name: 'evaluate', params: { docReference: resp.data.Data.document.system_number } });
                else
                  this.openDocument(resp.data.Data);
              } else {
                this.triggerNotification(
                  "You are not permitted to view this document",
                  "error"
                );
              }
              if (localStorage.getItem(linkType)) {
                localStorage.removeItem(linkType);
              }
            } else {
              this.errMessage = resp.data.message;
            }
          })
          .catch((err) => {
            alert("Server Error: " + err);
          });
        return true;
      } else {
        return false;
      }
    },
    logout() {
      axios.get("auth/logout/")
        .then(() => {
          this.$loginState.isAuthenticated = false;
          this.unloadClient();
          this.$store.dispatch("wordChecks/unload");
          this.$store.dispatch("customers/unload");
          localStorage.removeItem("rmapit");
          localStorage.removeItem("rmsso");
          this.qaActions.length = 0;
          if (this.$route.name !== "default")
            this.$router.replace({ name: "default" });

          this.setPasswordToken = "";
          this.$zendesk.logout();
          this.showLogin();
        });
    },
    showLogin() {
      this.doLogin = true;
      //this.$loginState.doLogin = true;
    },
    addDashboardActions(dashboards) {
      if (!dashboards) return;

      const routes = this.$router.addDashboardRoutes(dashboards);
      routes.forEach((route) => {
        this.qaActions.push(route);
      });
    },
    setAvailableActions() {
      this.qaActions.length = 0;
      if (this.$loginState.isAuthenticated) {
        if (this.$loginState.user.clientDashboards)
          this.$router.addDashboardRoutes(
            this.$loginState.user.clientDashboards
          );

        if (this.$loginState.user.landingPageConfigs)
          this.$router.addLandingPages(
            this.$loginState.user.landingPageConfigs
          );

        if (this.$loginState.user.routeMetaOverrides)
          this.$router.applyRouteMetaOverrides(
            this.$loginState.user.routeMetaOverrides
          );

        this.qaActions.push(
          ...this.$router
            .getRoutes()
            .map((r, ri) => {
              r.position = r.meta?.position || 100 + ri;
              return r;
            })
            .filter(
              (r) =>
                r.meta?.allowAll || (r.meta?.newUi &&
                (this.$loginState.user.userPermittedRoutes.some(
                  (pr) => pr === r.name
                ) ||
                  this.$loginState.user.landingPageConfigs.some(
                    (lp) => lp.page_route === r.name
                  )))
            )
            .sort((a, b) => a.position - b.position)
        );

        if (this.myQaActions.length > 0) {
          this.$loginState.permittedRoutes = this.qaActions.map((r) => r.name);
          let defaultPage = this.myQaActions.find(
            (a) => a.name === this.$loginState.getUserSetting("default_page")
          );
          if (!defaultPage) defaultPage = this.myQaActions[0];
          this.$loginState.defaultRoute = defaultPage.name;
          this.validateCurrentRoute();
        }
      } else if (this.$route.name !== "default") {
        this.$router.push({ name: "default" });
      }
    },
    validateCurrentRoute() {
      const currentPath = this.$route.name;
      if (!this.$loginState.permittedRoutes.includes(currentPath)) {
        this.$router.replace({
          name: this.$loginState.defaultRoute,
          params: { user: this.selectedUserIdx },
        });
      } else if (this.$route.params.user != this.selectedUserIdx) {
        this.$router.replace({
          name: this.$route.name,
          params: { user: this.selectedUserIdx },
        });
      }
    },
    applyTheme(themeName) {
      this.$store.commit(
        "theme/setAvailableThemes",
        this.$loginState.user.settings.find(
          (s) => s.setting == "allowed_themes"
        )
      );
      this.$store.commit("theme/setTheme", themeName);
      this.$vuetify.theme.dark = this.$store.state.theme.dark;
      this.$vuetify.theme.themes.dark.primary =
        this.$store.state.theme.primaryColor;
      this.$vuetify.theme.themes.light.primary =
        this.$store.state.theme.primaryColor;
      this.$vuetify.theme.themes.dark.secondary =
        this.$store.state.theme.secondaryColor;
      this.$vuetify.theme.themes.light.secondary =
        this.$store.state.theme.secondaryColor;
    },
    documentCreated(item, viewSource = false) {
      this.selectedDocumentId = item.system_number;
      this.selectedDocumentViewAction = item.viewAction;
      this.showAddDocument = false;
      this.showEvaluateNew = false;
      this.isNewDocument = true;
      this.viewSourceDoc = viewSource;
      if (item.doc_type == "External File") {
        this.showExternalDocument = true;
      } else {
        this.showDocument = true;
      }
      this.docCopied = false;
      this.docCopiedLink = false;
      this.documentOpened({
        system_number: item.system_number,
        doc_name: item.doc_name,
        doc_type: item.doc_type,
      });
      if (this.notifyDocumentChange) {
        this.notifyDocumentChange(item);
      }
    },
    documentLoadError(resp) {
      this.response = resp;
      this.closeDocument();
    },
    closeDocument() {
      this.selectedDocumentId = null;
      this.selectedDocumentViewAction = null;
      this.showDocument = false;
      this.docCopied = false;
      this.docCopiedLink = false;
    },
    closeExternalDocument() {
      this.selectedDocumentId = null;
      this.selectedDocumentViewAction = null;
      this.showExternalDocument = false;
      this.docCopied = false;
      this.docCopiedLink = false;
    },
    documentHeaderSaved(item) {
      if (this.notifyDocumentChange) {
        this.notifyDocumentChange(item);
      }
    },
    addDocument(defaultDoc) {
      this.showAddDocument = true;
      this.defaultDoc = defaultDoc;
    },
    evaluateNewDocument(defaultDoc) {
      this.showEvaluateNew = true;
      this.defaultDoc = defaultDoc;
    },
    closeAddDocument() {
      this.showAddDocument = false;
      this.showEvaluateNew = false;
    },
    documentOpened(item) {
      this.recentDocs = utils.addRecentDoc(this.$loginState, item);
    },
    async openDocument(doc, isNew, isNewLink) {
      let docId = doc.reference || doc.document_reference || doc.system_number || doc.id;
      let docListItem = doc;
      let docType = docListItem?.tmpl_name || doc.doc_type || doc.document_type || doc.tmpl_name;
      let docName = docListItem?.doc_title || docListItem?.doc_name || doc.document_name || doc.doc_name || doc.title;
      if (docId && (!docListItem.viewAction || !docType || !docName)) {
        await this.$store.getters["docs/filter"]({ systemNumbersIncluded: [ docId ]})
          .then(dl => {
            docListItem = dl.length ? dl[0] : null;
            docType = docListItem?.doc_type;
            docName = docListItem?.doc_title || docListItem?.doc_name;
          });
        if (!docListItem) {
          // The docs list/index caches lag behind creation (10-min store
          // refresh; redis TTL) — a document created moments ago (e.g. by
          // the Atlas doc-upload flow, which auto-opens its result) isn't
          // in them yet. Confirm against the live, permission-checked
          // document endpoint before declaring permission lost.
          const live = await axios
            .get("document/docswithparts/" + docId)
            .then((resp) =>
              resp.data.Status === "OK" && resp.data.Data.documents?.length
                ? resp.data.Data.documents[0]
                : null
            )
            .catch(() => null);
          if (live && live.viewAction) {
            this.openDocument(live, isNew, isNewLink);
            return;
          }
          alert("You no longer have permission to view this document");
          return;
        }
      }
      this.selectedDocumentViewAction = docListItem.viewAction;
      this.selectedDocumentId = docId;
      this.refDocument = null;
      this.isNewDocument = false;
      this.viewSource = false;
      if (docType == "External File" || doc.tmpl_name == "External File") {
        this.showExternalDocument = true;
        this.showDocument = false;
      } else {
        this.showDocument = true;
        this.showExternalDocument = false;
      }
      this.openFlex = doc.openFlex;
      this.docCopied = isNew;
      this.docCopiedLink = !!isNewLink;
      this.documentOpened({
        system_number: docId,
        doc_name: docName,
        doc_type: docType,
      });
    },
    copyDocument(item, tmpl_id, uploaded, action_available_id_copy, lifecycle_id_destination) {
      tmpl_id = tmpl_id || item.tmpl_id;

      const createOption = this.$loginState.user.createDocumentOptions.find(
        (a) => a.tmpl_id === tmpl_id
      );
      const isNewLink =
        tmpl_id && item.tmpl_id ? tmpl_id !== item.tmpl_id : false;

      if (!createOption) {
        this.response = { message: "No permission to create document" };
        return;
      }

      let action;
      if (createOption.lifecycles && createOption.lifecycles.length === 1) {
        action = createOption.lifecycles[0];
      } else if (
        lifecycle_id_destination &&
        createOption.lifecycles &&
        createOption.lifecycles.some(
          (x) => x.lifecycle_id === lifecycle_id_destination
        )
      ) {
        action = createOption.lifecycles.find(
          (x) => x.lifecycle_id === lifecycle_id_destination
        );
      } else if (
        createOption.lifecycles &&
        createOption.lifecycles.length > 1
      ) {
        action = createOption.lifecycles.find((x) => x.isDefault);
      }

      let data = {
        source_doc_id: item.doc_id,
        tmpl_id: tmpl_id || item.tmpl_id,
        action: action,
        action_available_id_copy: action_available_id_copy,
      };

      this.isLoading = true;
      axios
        .post("document/copyDocument/", data)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            let doc = resp.data.Data;
            //let doc = resp.data.Data[0][0];
            //doc.source_doc_id = item.doc_id;
            this.$store.dispatch("docs/addCopy", doc);
            // if (uploaded) {
            //   resp.data.Data[0].file_data = uploaded[0];
            //   resp.data.Data[0].doc_id = doc.doc_id;
            //   this.linkFileToDoc(resp.data.Data[0]);
            // }
            if (uploaded) {
              resp.data.Data.file_data = uploaded[0];
              //resp.data.Data.doc_id = doc.doc_id;
              this.linkFileToDoc(resp.data.Data);
            }
            // this.openDocument(doc, !Number(doc.groupMemberAdded));
            this.openDocument(doc, true, isNewLink);
          } else {
            alert(resp.data.Message);
          }
          this.response = resp.data;
          console.log(resp);
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.sessionExpired(err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
    closeCookies() {
      this.showCookies = false;
    },
    showCookieDialog() {
      this.showCookies = true;
    },
    triggerNotification(text, type) {
      this.errorText = text;
      this.snackColor = type;
      this.showErrorSnack = true;
    },
    linkFileToDoc(docData) {
      this.isLoading = true;
      let data = {
        doc_id: docData.doc_id,
        file_id: docData.file_data.file_id,
      };

      axios
        .post("file/linkFileToDoc/", data)
        .then((resp) => {
          this.response = resp.data;
          console.log(resp);
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/theme.scss";
@import "./assets/styles/custom.scss";

.v-application {
  height: 100vh;
}

.app-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;

  .side-menu {
    flex-shrink: 0;
  }

  .app-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  // Row beneath the header: the contextual drawer + the page. Keeps the drawer
  // INSIDE the main page (below the header) rather than beside the rail.
  .app-body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;

    > .v-main {
      flex: 1 1 auto;
      min-width: 0;
      min-height: 0;
      overflow-y: auto;
    }
  }

  // V2 chrome only: dark backdrop (matches the rail/header) so the content
  // plane's rounded top corners reveal a curved join into the chrome — like the
  // beta workspace. Scoped so the classic UI is untouched.
  &.app-layout--v3 .app-content {
    background: #16181d;

    .app-body > .v-main {
      background: #ffffff;
      border-top-right-radius: 16px;
      // When there's no drawer, the page is the leftmost plane → round both.
      &:first-child { border-top-left-radius: 16px; }
    }
  }
}

// Dark theme: the content plane flips to the prototype's dark surface-2 so the
// token-driven v3 widgets (which restyle themselves via .uitheme-dark) sit on a
// matching body. The chrome backdrop (#16181d) is already dark in both modes.
.uitheme-dark .app-layout.app-layout--v3 .app-content .app-body > .v-main,
.uitheme-highcontrast .app-layout.app-layout--v3 .app-content .app-body > .v-main {
  background: #20262f;
}

// Dark v3 chrome: the rail / backdrop / top bar drop from the light-mode #16181d
// to a deeper near-black (#0a0c10, the beta prototype's dark rail) so the content
// plane's rounded top corners reveal the correct dark curve — matching beta.
.uitheme-dark .app-layout.app-layout--v3 .app-content,
.uitheme-highcontrast .app-layout.app-layout--v3 .app-content {
  background: #0a0c10;
}
.uitheme-dark .app-layout.app-layout--v3 .side-rail,
.uitheme-highcontrast .app-layout.app-layout--v3 .side-rail {
  background: #0a0c10;
}
.uitheme-dark .v2ui-application-header,
.uitheme-highcontrast .v2ui-application-header {
  background-color: #0a0c10 !important;
}

.network-error {
  position: fixed;
  bottom: 2px;
  right: 20px;
  z-index: 9999;
}
.v2ui-application-header {
  // Unify the top bar with the app rail (both #16181d) so the chrome reads as
  // one dark surface, matching the rm-portal-beta prototype TopBar.
  background-color: #16181d !important;
  color: #ffffff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;

  // Icons sit dim and brighten on hover (prototype .v3-top-icon behaviour).
  .v-icon {
    color: #b7bdc9 !important;
  }
  .v-btn:hover .v-icon,
  .v-btn--icon:hover .v-icon,
  .v-btn:focus-visible .v-icon {
    color: #ffffff !important;
  }

  // Header action buttons (Create / Feedback / Create Job) — uniform size +
  // spacing, nudged down a touch for top breathing room.
  .v3-hdr-btn.v-btn {
    height: 30px !important;
    min-width: 88px;
    margin: 0 4px;
    padding: 0 14px;
    border-radius: 8px;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
    font-size: 13px;

    // Icons on solid action buttons stay white (not the dim header colour).
    .v-icon { color: #ffffff !important; }
  }
}
.rm-header-avatar-text {
  color: black;
  font-size: 20px;
  font-weight: 700;
  font-family: 'DM Sans' !important;
  letter-spacing: -6%;
}
.rm-header-title-text {
  color: white;
  font-size: 20px;
  font-weight: 700;
  font-family: 'DM Sans' !important;
  letter-spacing: -6%;
}
.rm-header-title-label {
  color: white !important;
  font-size: 14px !important;
  font-weight: 400;
  font-family: 'DM Sans' !important;
  text-transform: uppercase;
}
.rm-user-avatar-text {
  color: black;
  font-size: 14px;
  font-weight: 400;
  font-family: 'DM Sans' !important;
  letter-spacing: -6%;
}

/*
 * Atlas side-panel coupling. When the flyout is open, v-main reserves
 * matching right-padding so router-view shrinks instead of being
 * overlaid. The transition matches the flyout's slide-in (0.22s ease),
 * and is suspended during a drag so the panel edge and the content
 * margin track the cursor in lockstep rather than the content lagging
 * behind.
 */
.mainContent {
  transition: padding-right 0.22s ease;
}
.mainContent--atlas-resizing {
  transition: none;
}
</style>
